import {
  faBug,
  faCircleInfo,
  faCirclePlus,
  faPenToSquare,
  faTrash,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';
import { LogChangelogChangeType } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { type MaybeRef } from 'vue';
import { useBadgeInfoObject } from '../style/useBadgeInfoObject';
import { type DisplayBadgeType } from '../style/useDisplayBadgeClass';

export const useChangelogChangeTypeInfo = (colorType: MaybeRef<DisplayBadgeType> = 'badge') => {
  const {
    badgeInfo,
    getBadgeClass,
    getBadgeColor,
    getBadgeIcon,
    getBadgeTitle,
    getBadgeInfo,
  } = useBadgeInfoObject<LogChangelogChangeType>(
    {
      i18nPrefix: 'dialog.version-history.change-type',
      colorMap: {
        [LogChangelogChangeType.FEATURE]: 'success',
        [LogChangelogChangeType.BUGFIX]: 'warning',
        [LogChangelogChangeType.REFACTOR]: 'neutral',
        [LogChangelogChangeType.REVERT]: 'error',
        [LogChangelogChangeType.PERFORMANCE]: 'primary',
        [LogChangelogChangeType.STYLE]: 'primary',
        [LogChangelogChangeType.TEST]: 'primary',
        [LogChangelogChangeType.DOCUMENTATION]: 'primary',
        [LogChangelogChangeType.CHORE]: 'primary',
        [LogChangelogChangeType.BUILD]: 'primary',
        [LogChangelogChangeType.CI]: 'primary',
        [LogChangelogChangeType.OTHER]: 'neutral',
      },
      iconMap: {
        [LogChangelogChangeType.FEATURE]: faCirclePlus,
        [LogChangelogChangeType.BUGFIX]: faBug,
        [LogChangelogChangeType.REFACTOR]: faWandMagicSparkles,
        [LogChangelogChangeType.REVERT]: faTrash,
        [LogChangelogChangeType.PERFORMANCE]: faPenToSquare,
        [LogChangelogChangeType.STYLE]: faPenToSquare,
        [LogChangelogChangeType.TEST]: faPenToSquare,
        [LogChangelogChangeType.DOCUMENTATION]: faPenToSquare,
        [LogChangelogChangeType.CHORE]: faPenToSquare,
        [LogChangelogChangeType.BUILD]: faPenToSquare,
        [LogChangelogChangeType.CI]: faPenToSquare,
        [LogChangelogChangeType.OTHER]: faCircleInfo,
      },
      defaultColor: 'neutral',
      defaultIcon: faCircleInfo,
    },
    colorType,
  );

  return {
    changelogChangeTypeInfo: badgeInfo,
    getChangelogChangeTypeTitle: getBadgeTitle,
    getChangelogChangeTypeClass: getBadgeClass,
    getChangelogChangeTypeColor: getBadgeColor,
    getChangelogChangeTypeIcon: getBadgeIcon,
    getChangelogChangeTypeInfo: getBadgeInfo,
  };
};
